import { useState, useRef, Fragment } from "react";
import Config from "../../Config";



export default function Print(props)
{

   const linkRef = useRef(0);
   const [tab,setTab] = useState(null);

    const[status, setStatus] = useState(0);  //1-start downloading //2-finish downloading
    const[stream, setStream] = useState("");


    const base64PDFToBlobUrl = ( base64 ) => {
        const binStr = atob( base64 );
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            arr[ i ] = binStr.charCodeAt( i );
        }
        const blob =  new Blob( [ arr ], { type: 'application/pdf' } );
        const url = URL.createObjectURL( blob );
        return url;
        }


const getDoc = () => {
       
 
    props.mainView.setProgress(-2);

   
    var req = {
        id: props.id,
        typ: props.typ,
    };

    fetch( Config.url + '/rest_v1_men,print', {
        method: 'POST', 
        body: JSON.stringify(req), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTab(res.result); 
                    setStream(res.result.result.b64) ;
                    setStatus(2);
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}


 


    if(tab == null )
    {
           setStatus(1);
        setTab([]);
        getDoc();
       
    }


    var urlBlob = null;
    if(status == 2 &&   props.typ.includes("pdf")  )
    {
        urlBlob = base64PDFToBlobUrl(stream);
    }
 
    console.log("BBBB", urlBlob);
    
    return <div className="dlg_window dlg_type_x shadowx">

        {
            status == 2 &&
            <Fragment>
                                   <div className="gocenter">    
                                        &nbsp;
                                        <br/>
                                        <br/>                                                       

                                          {
                                              urlBlob != null &&  props.typ.includes("pdf") &&
                                              <Fragment>
                                                    <a className=" big_btn"  target="_blank"  href={urlBlob} download={  props.title  } ref={linkRef} onClick={props.onClose}>Pobierz plik </a>                                            
                                                    <br/>
                                              </Fragment>
                                           }

                                          {
                                             urlBlob == null &&  props.typ.includes("pdf") &&
                                              <Fragment>
                                                    <a className=" big_btn"  target="_blank"  href={"data:application/pdf;base64," + stream} download={  props.title  } ref={linkRef} onClick={props.onClose}>Pobierz plik</a>                                            
                                                    <br/>
                                              </Fragment>
                                           }

 

                                           {
                                              props.typ.includes("xml") &&
                                              <Fragment>
                                                    <a className=" big_btn"  target="_blank"  href={"data:application/octet-stream;base64," + stream} download={   props.title } ref={linkRef} onClick={props.onClose}>Pobierz plik</a>                                            
                                                    <br/>
                                              </Fragment>
                                           }
                                         
                                            <br/>
                                            <br/>
                                            <span className="btn" onClick={props.onClose}> anuluj</span>
                                            <br/>&nbsp;
                                    </div>  


            </Fragment>
        }


        {
            status == 1 &&
            <Fragment>

                <div className="gocenter">
                                
                                &nbsp;
                                <br/>
                                <br/>
                                Proszę czekaj, trwa generowanie dokumentu...
                                <br/>
                                <br/>
                                <br/>
                                <span className="btn" onClick={props.onClose}> anuluj</span>
                                <br/>&nbsp;
                        </div>   

            </Fragment>
        }

          

    </div>
}

